// extracted by mini-css-extract-plugin
export default {"services":"style_services__XBhO6","gridServices":"style_gridServices__2suYl","service":"style_service__Y9MQH","title":"style_title__N2NYT"};